'use strict';
import axios from 'axios';
var ArctickClient = require('../../../../sdk/apiClient');
var util = require('util');


function Offers() {
    ArctickClient.apply(this, arguments);
}

util.inherits(Offers, ArctickClient);

Offers.prototype.getOffers = function(){
    
    var deferred = $.Deferred();
    
    let url = process.env.PROTOCOL + "://" + process.env.BASE_URL + "/api/v2/items"

    let data = {
        "pageSize": 0,
        "pageNumber": 1,
        "Sort": "-price",
        "Categories": [
        process.env.OFFERS
        ]
    }
    let config = {
        headers:{
            'Content-Type': 'application/json'
        }
    }

    axios.post(url,data,config)
    .then(response => {

        deferred.resolve(response.data.Records);
        
    })
    .catch(error => console.error(error));

    return deferred.promise();
}

module.exports = Offers



